import { postAction } from '../core/http.js';
import { getStateVersion, subscribe } from '../state/store.js';

const cache = new Map();
let knownVersion = getStateVersion();

function cacheKey(type, id) {
  return type + ':' + id;
}

function previewAction(type) {
  return type === 'carrier' ? 'previewCarrier' : 'previewPayment';
}

function previewParams(type, id) {
  return type === 'carrier' ? { id_carrier: id } : { id_payment: id };
}

export function invalidate() {
  cache.clear();
}

export function prefetch(type, id) {
  if (!id) {
    return;
  }

  const key = cacheKey(type, id);
  if (cache.has(key)) {
    return;
  }

  const record = { fragments: null };
  cache.set(key, record);

  postAction(previewAction(type), previewParams(type, id))
    .then((response) => {
      record.fragments = response && response.fragments ? response.fragments : null;
    })
    .catch(() => {
      cache.delete(key);
    });
}

export function getReadyFragments(type, id) {
  const record = cache.get(cacheKey(type, id));

  return record ? record.fragments : null;
}

function onVersionChange(state) {
  const version = state.stateVersion;

  if (version === null) {
    return;
  }

  if (knownVersion !== null && version !== knownVersion) {
    invalidate();
  }

  knownVersion = version;
}

function radioFromIntent(target, name) {
  if (!target || typeof target.closest !== 'function') {
    return null;
  }

  const direct = target.closest('[name="' + name + '"]');
  if (direct) {
    return direct;
  }

  const row = target.closest('.select-block, .st-radio-block, label, .custom-control');

  return row ? row.querySelector('[name="' + name + '"]') : null;
}

function onIntent(event) {
  const payment = radioFromIntent(event.target, 'id_payment');
  if (payment && payment.value) {
    prefetch('payment', payment.value);
  }

  const carrier = radioFromIntent(event.target, 'id_carrier');
  if (carrier && carrier.value) {
    prefetch('carrier', carrier.value);
  }
}

export function registerPrefetch() {
  document.addEventListener('pointerover', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent);
  subscribe(onVersionChange);
}
